import StartupFundraiseAdd from './container';

export default StartupFundraiseAdd;
